var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320.29297pt",
    height: "800.29297pt",
    viewBox: "0 0 320.29297 800.29296",
    id: "svg297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.953125,6.0625 C 4.785156,6.445312 4.382812,6.640625 3.75,6.640625 c -0.179688,0 -0.355469,-0.023437 -0.53125,-0.0625 l -0.921875,-0.25 C 1.273438,6.054688 0.59375,5.519531 0.25,4.71875 0.0820312,4.3125 0,3.847656 0,3.328125 V 1.546875 C 0,1.242188 0.148438,1.09375 0.453125,1.09375 c 0.3125,0 0.46875,0.148438 0.46875,0.453125 v 2.03125 c 0,0.394531 0.128906,0.765625 0.390625,1.109375 0.269531,0.351562 0.597656,0.582031 0.984375,0.6875 l 0.921875,0.25 c 0.1875,0.039062 0.359375,0.0625 0.515625,0.0625 0.570313,0 0.859375,-0.375 0.859375,-1.125 V 3.734375 c 0,-0.3125 0.148438,-0.46875 0.453125,-0.46875 0.3125,0 0.46875,0.15625 0.46875,0.46875 V 4.8125 c 0,0.550781 0.226563,1.023438 0.6875,1.421875 0.207031,0.1875 0.4375,0.3125 0.6875,0.375 0.15625,0.03125 0.289063,0.046875 0.40625,0.046875 0.644531,0 0.96875,-0.371094 0.96875,-1.109375 v -1.78125 c 0,-0.304687 0.15625,-0.453125 0.46875,-0.453125 0.300781,0 0.453125,0.148438 0.453125,0.453125 v 2.03125 c 0,0.71875 -0.320312,1.242187 -0.953125,1.578125 -0.292969,0.15625 -0.59375,0.234375 -0.90625,0.234375 -0.148437,0 -0.292969,-0.023437 -0.4375,-0.0625 -1,-0.261719 -1.648437,-0.757813 -1.9375,-1.484375 z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.921875,3.5625 c 0,0.945312 0.457031,1.550781 1.375,1.8125 l 0.921875,0.25 c 0.1875,0.039062 0.359375,0.0625 0.515625,0.0625 0.570313,0 0.859375,-0.382812 0.859375,-1.140625 V 3.125 L 2.296875,2.515625 c -0.136719,-0.042969 -0.25,-0.0625 -0.34375,-0.0625 -0.3125,0 -0.5625,0.101563 -0.75,0.3125 C 1.015625,2.984375 0.921875,3.25 0.921875,3.5625 Z M 0,3.328125 c 0,-0.65625 0.335938,-1.179687 1.015625,-1.5625 0.289063,-0.167969 0.59375,-0.25 0.90625,-0.25 0.125,0 0.242187,0.015625 0.359375,0.046875 l 2.765625,0.734375 c 1.03125,0.28125 1.882813,0.738281 2.5625,1.375 C 8.378906,4.398438 8.898438,5.34375 9.171875,6.5 9.179688,6.53125 9.1875,6.566406 9.1875,6.609375 c 0,0.3125 -0.152344,0.46875 -0.453125,0.46875 -0.261719,0 -0.40625,-0.105469 -0.4375,-0.3125 C 8.222656,6.253906 8.03125,5.738281 7.71875,5.21875 7.15625,4.289062 6.421875,3.695312 5.515625,3.4375 v 1.359375 c 0,0.53125 -0.167969,0.96875 -0.5,1.3125 C 4.679688,6.460938 4.25,6.640625 3.71875,6.640625 c -0.179688,0 -0.34375,-0.023437 -0.5,-0.0625 l -0.921875,-0.25 C 1.222656,6.023438 0.535156,5.503906 0.234375,4.765625 0.078125,4.378906 0,3.898438 0,3.328125 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.53125,6.5 0.21875,3.84375 C 0.0703125,3.75 0,3.617188 0,3.453125 0,3.328125 0.046875,3.21875 0.140625,3.125 0.234375,3.03125 0.34375,2.988281 0.46875,3 L 8.75,3.296875 c 0.289062,0.00781 0.4375,0.164063 0.4375,0.46875 0,0.320313 -0.164062,0.476563 -0.484375,0.46875 L 2.171875,3.96875 6.203125,6.4375 C 6.359375,6.53125 6.4375,6.65625 6.4375,6.8125 6.4375,7.113281 6.289062,7.273438 6,7.296875 L 2.109375,7.609375 8.9375,10.96875 c 0.164062,0.08203 0.25,0.21875 0.25,0.40625 0,0.3125 -0.148438,0.46875 -0.4375,0.46875 -0.085938,0 -0.15625,-0.01563 -0.21875,-0.04687 L 0.25,7.6875 C 0.0820312,7.601562 0,7.46875 0,7.28125 0,6.988281 0.140625,6.832031 0.421875,6.8125 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.921875,5.359375 c 0,0.300781 -0.15625,0.453125 -0.46875,0.453125 C 0.148438,5.8125 0,5.660156 0,5.359375 v -3.9375 C 0,1.285156 0.0390625,1.179688 0.125,1.109375 0.21875,1.046875 0.328125,1.035156 0.453125,1.078125 l 8.390625,2.25 c 0.226562,0.0625 0.34375,0.207031 0.34375,0.4375 0,0.300781 -0.152344,0.453125 -0.453125,0.453125 -0.054687,0 -0.09375,0 -0.125,0 l -7.6875,-2.0625 z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.59375,5.640625 v -2.5 L 0.921875,2.15625 v 3.203125 c 0,0.300781 -0.15625,0.453125 -0.46875,0.453125 C 0.148438,5.8125 0,5.660156 0,5.359375 v -3.9375 C 0,1.285156 0.0390625,1.179688 0.125,1.109375 0.21875,1.046875 0.328125,1.035156 0.453125,1.078125 l 8.28125,2.21875 C 9.035156,3.367188 9.1875,3.566406 9.1875,3.890625 V 7.5625 c 0,0.3125 -0.152344,0.46875 -0.453125,0.46875 -0.3125,0 -0.46875,-0.15625 -0.46875,-0.46875 V 4.125 l -2.75,-0.734375 v 2.25 c 0,0.300781 -0.15625,0.453125 -0.46875,0.453125 -0.304687,0 -0.453125,-0.152344 -0.453125,-0.453125 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.734375,3.296875 C 9.035156,3.367188 9.1875,3.566406 9.1875,3.890625 V 6.75 c 0,0.476562 -0.203125,0.898438 -0.609375,1.265625 C 8.179688,8.378906 7.738281,8.5625 7.25,8.5625 7.132812,8.5625 7.015625,8.546875 6.890625,8.515625 L 2.296875,7.28125 C 0.765625,6.863281 0,5.863281 0,4.28125 V 1.421875 C 0,1.285156 0.0390625,1.179688 0.125,1.109375 0.21875,1.046875 0.328125,1.035156 0.453125,1.078125 Z M 8.265625,4.125 0.921875,2.15625 v 2.375 c 0,0.382812 0.128906,0.753906 0.390625,1.109375 0.269531,0.351563 0.597656,0.582031 0.984375,0.6875 L 6.890625,7.5625 c 0.125,0.03125 0.238281,0.046875 0.34375,0.046875 0.3125,0 0.5625,-0.109375 0.75,-0.328125 C 8.171875,7.070312 8.265625,6.8125 8.265625,6.5 Z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.6875,2.59375 C 5.875,2.050781 6.148438,1.648438 6.515625,1.390625 c 0.363281,-0.25 0.800781,-0.375 1.3125,-0.375 0.757813,0 1.394531,0.269531 1.90625,0.8125 0.519531,0.550781 0.78125,1.285156 0.78125,2.203125 0,0.90625 -0.265625,1.632812 -0.796875,2.1875 C 9.1875,6.78125 8.539062,7.0625 7.78125,7.0625 7.300781,7.0625 6.878906,6.9375 6.515625,6.6875 6.148438,6.4375 5.875,6.050781 5.6875,5.53125 5.476562,6.164062 5.140625,6.648438 4.671875,6.984375 4.203125,7.328125 3.644531,7.5 3,7.5 2.101562,7.5 1.347656,7.179688 0.734375,6.546875 c -0.605469,-0.636719 -0.90625,-1.46875 -0.90625,-2.5 0,-1.03125 0.300781,-1.867187 0.90625,-2.5 C 1.347656,0.910156 2.113281,0.59375 3.03125,0.59375 c 0.675781,0 1.242188,0.171875 1.703125,0.515625 0.46875,0.34375 0.785156,0.835937 0.953125,1.484375 z M 7.859375,2.328125 c -0.492187,0 -0.898437,0.15625 -1.21875,0.46875 -0.3125,0.320313 -0.46875,0.738281 -0.46875,1.25 0,0.5 0.15625,0.90625 0.46875,1.21875 C 6.953125,5.585938 7.335938,5.75 7.796875,5.75 c 0.46875,0 0.863281,-0.167969 1.1875,-0.5 C 9.304688,4.925781 9.46875,4.519531 9.46875,4.03125 9.46875,3.539062 9.304688,3.132812 8.984375,2.8125 8.671875,2.488281 8.296875,2.328125 7.859375,2.328125 Z M 3.03125,1.921875 c -0.375,0 -0.734375,0.082031 -1.078125,0.25 C 1.609375,2.347656 1.34375,2.609375 1.15625,2.953125 0.96875,3.296875 0.875,3.664062 0.875,4.0625 c 0,0.613281 0.195312,1.117188 0.59375,1.515625 0.394531,0.40625 0.898438,0.609375 1.515625,0.609375 0.613281,0 1.125,-0.210938 1.53125,-0.625 C 4.921875,5.15625 5.125,4.640625 5.125,4.015625 5.125,3.410156 4.921875,2.910156 4.515625,2.515625 4.117188,2.117188 3.625,1.921875 3.03125,1.921875 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5.171875,0.609375 c 1.238281,0 2.234375,0.125 2.984375,0.375 C 8.914062,1.242188 9.5,1.625 9.90625,2.125 c 0.40625,0.5 0.609375,1.132812 0.609375,1.90625 0,0.5625 -0.117187,1.050781 -0.34375,1.46875 -0.21875,0.425781 -0.542969,0.773438 -0.96875,1.046875 -0.429687,0.28125 -0.949219,0.5 -1.5625,0.65625 C 7.035156,7.359375 6.210938,7.4375 5.171875,7.4375 c -1.230469,0 -2.226563,-0.125 -2.984375,-0.375 -0.75,-0.25 -1.335938,-0.632812 -1.75,-1.140625 -0.40625,-0.5 -0.609375,-1.132813 -0.609375,-1.890625 0,-1.011719 0.359375,-1.808594 1.078125,-2.390625 0.875,-0.6875 2.296875,-1.03125 4.265625,-1.03125 z m 0,1.328125 c -1.71875,0 -2.867187,0.195312 -3.4375,0.59375 C 1.160156,2.9375 0.875,3.4375 0.875,4.03125 c 0,0.582031 0.285156,1.078125 0.859375,1.484375 0.570313,0.40625 1.71875,0.609375 3.4375,0.609375 1.71875,0 2.859375,-0.203125 3.421875,-0.609375 0.570312,-0.40625 0.859375,-0.90625 0.859375,-1.5 0,-0.59375 -0.25,-1.070313 -0.75,-1.421875 C 8.066406,2.15625 6.890625,1.9375 5.171875,1.9375 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,1.078125 h 10.484375 v 1.375 h -9.25 V 7.625 H 0 Z m 0,0",
    id: "path9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 6.0625,-4.953125 c 0.382812,0.167969 0.578125,0.570313 0.578125,1.203125 0,0.179688 -0.023437,0.355469 -0.0625,0.53125 l -0.25,0.921875 C 6.054688,-1.273438 5.519531,-0.59375 4.71875,-0.25 4.3125,-0.0820312 3.847656,0 3.328125,0 H 1.546875 C 1.242188,0 1.09375,-0.148438 1.09375,-0.453125 c 0,-0.3125 0.148438,-0.46875 0.453125,-0.46875 h 2.03125 c 0.394531,0 0.765625,-0.128906 1.109375,-0.390625 0.351562,-0.269531 0.582031,-0.597656 0.6875,-0.984375 l 0.25,-0.921875 c 0.039062,-0.1875 0.0625,-0.359375 0.0625,-0.515625 0,-0.570313 -0.375,-0.859375 -1.125,-0.859375 H 3.734375 c -0.3125,0 -0.46875,-0.148438 -0.46875,-0.453125 0,-0.3125 0.15625,-0.46875 0.46875,-0.46875 H 4.8125 c 0.550781,0 1.023438,-0.226563 1.421875,-0.6875 0.1875,-0.207031 0.3125,-0.4375 0.375,-0.6875 0.03125,-0.15625 0.046875,-0.289063 0.046875,-0.40625 0,-0.644531 -0.371094,-0.96875 -1.109375,-0.96875 h -1.78125 c -0.304687,0 -0.453125,-0.15625 -0.453125,-0.46875 0,-0.300781 0.148438,-0.453125 0.453125,-0.453125 h 2.03125 c 0.71875,0 1.242187,0.320312 1.578125,0.953125 0.15625,0.292969 0.234375,0.59375 0.234375,0.90625 0,0.148437 -0.023437,0.292969 -0.0625,0.4375 -0.261719,1 -0.757813,1.648437 -1.484375,1.9375 z m 0,0",
    id: "path10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.5625,-0.921875 c 0.945312,0 1.550781,-0.457031 1.8125,-1.375 l 0.25,-0.921875 c 0.039062,-0.1875 0.0625,-0.359375 0.0625,-0.515625 0,-0.570313 -0.382812,-0.859375 -1.140625,-0.859375 H 3.125 l -0.609375,2.296875 c -0.042969,0.136719 -0.0625,0.25 -0.0625,0.34375 0,0.3125 0.101563,0.5625 0.3125,0.75 0.21875,0.1875 0.484375,0.28125 0.796875,0.28125 z M 3.328125,0 c -0.65625,0 -1.179687,-0.335938 -1.5625,-1.015625 -0.167969,-0.289063 -0.25,-0.59375 -0.25,-0.90625 0,-0.125 0.015625,-0.242187 0.046875,-0.359375 l 0.734375,-2.765625 c 0.28125,-1.03125 0.738281,-1.882813 1.375,-2.5625 C 4.398438,-8.378906 5.34375,-8.898438 6.5,-9.171875 6.53125,-9.179688 6.566406,-9.1875 6.609375,-9.1875 c 0.3125,0 0.46875,0.152344 0.46875,0.453125 0,0.261719 -0.105469,0.40625 -0.3125,0.4375 C 6.253906,-8.222656 5.738281,-8.03125 5.21875,-7.71875 4.289062,-7.15625 3.695312,-6.421875 3.4375,-5.515625 h 1.359375 c 0.53125,0 0.96875,0.167969 1.3125,0.5 0.351563,0.335937 0.53125,0.765625 0.53125,1.296875 0,0.179688 -0.023437,0.34375 -0.0625,0.5 l -0.25,0.921875 c -0.304687,1.074219 -0.824219,1.761719 -1.5625,2.0625 C 4.378906,-0.078125 3.898438,0 3.328125,0 Z m 0,0",
    id: "path11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 6.5,-4.53125 -2.65625,4.3125 C 3.75,-0.0703125 3.617188,0 3.453125,0 3.328125,0 3.21875,-0.046875 3.125,-0.140625 3.03125,-0.234375 2.988281,-0.34375 3,-0.46875 L 3.296875,-8.75 c 0.00781,-0.289062 0.164063,-0.4375 0.46875,-0.4375 0.320313,0 0.476563,0.164062 0.46875,0.484375 l -0.265625,6.53125 2.46875,-4.03125 c 0.09375,-0.15625 0.21875,-0.234375 0.375,-0.234375 0.300781,0 0.460938,0.148438 0.484375,0.4375 l 0.3125,3.890625 3.359375,-6.828125 c 0.08203,-0.164062 0.21875,-0.25 0.40625,-0.25 0.3125,0 0.46875,0.148438 0.46875,0.4375 0,0.085938 -0.01563,0.15625 -0.04687,0.21875 L 7.6875,-0.25 C 7.601562,-0.0820312 7.46875,0 7.28125,0 6.988281,0 6.832031,-0.140625 6.8125,-0.421875 Z m 0,0",
    id: "path12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5.359375,-0.921875 c 0.300781,0 0.453125,0.15625 0.453125,0.46875 C 5.8125,-0.148438 5.660156,0 5.359375,0 h -3.9375 C 1.285156,0 1.179688,-0.0390625 1.109375,-0.125 1.046875,-0.21875 1.035156,-0.328125 1.078125,-0.453125 l 2.25,-8.390625 c 0.0625,-0.226562 0.207031,-0.34375 0.4375,-0.34375 0.300781,0 0.453125,0.152344 0.453125,0.453125 0,0.054687 0,0.09375 0,0.125 l -2.0625,7.6875 z m 0,0",
    id: "path13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5.640625,-4.59375 h -2.5 L 2.15625,-0.921875 h 3.203125 c 0.300781,0 0.453125,0.15625 0.453125,0.46875 C 5.8125,-0.148438 5.660156,0 5.359375,0 h -3.9375 C 1.285156,0 1.179688,-0.0390625 1.109375,-0.125 1.046875,-0.21875 1.035156,-0.328125 1.078125,-0.453125 l 2.21875,-8.28125 C 3.367188,-9.035156 3.566406,-9.1875 3.890625,-9.1875 H 7.5625 c 0.3125,0 0.46875,0.152344 0.46875,0.453125 0,0.3125 -0.15625,0.46875 -0.46875,0.46875 H 4.125 l -0.734375,2.75 h 2.25 c 0.300781,0 0.453125,0.15625 0.453125,0.46875 0,0.304687 -0.152344,0.453125 -0.453125,0.453125 z m 0,0",
    id: "path14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.296875,-8.734375 C 3.367188,-9.035156 3.566406,-9.1875 3.890625,-9.1875 H 6.75 c 0.476562,0 0.898438,0.203125 1.265625,0.609375 C 8.378906,-8.179688 8.5625,-7.738281 8.5625,-7.25 c 0,0.117188 -0.015625,0.234375 -0.046875,0.359375 L 7.28125,-2.296875 C 6.863281,-0.765625 5.863281,0 4.28125,0 H 1.421875 C 1.285156,0 1.179688,-0.0390625 1.109375,-0.125 1.046875,-0.21875 1.035156,-0.328125 1.078125,-0.453125 Z m 0.828125,0.46875 -1.96875,7.34375 h 2.375 c 0.382812,0 0.753906,-0.128906 1.109375,-0.390625 0.351563,-0.269531 0.582031,-0.597656 0.6875,-0.984375 L 7.5625,-6.890625 c 0.03125,-0.125 0.046875,-0.238281 0.046875,-0.34375 0,-0.3125 -0.109375,-0.5625 -0.328125,-0.75 C 7.070312,-8.171875 6.8125,-8.265625 6.5,-8.265625 Z m 0,0",
    id: "path15"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g297",
    transform: "translate(-141.77344,-19.734375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00148533,-1.98e-4 H -74.402527 m -11.197917,0 H -96.64211 m -11.19792,0 h -11.04166 m -11.03646,0 h -55.52083 m -11.20313,0 h -11.03646 m -11.04166,0 h -11.19792 m -11.04167,0 h -55.52083 m -11.04167,0 h -11.19791 m -11.04167,0 h -11.19792",
    transform: "matrix(0.75,0,0,0.75,461.88002,819.83999)",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 263.83854,1093.1198 h -74.55729 v -61.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,6.15333e-4 V -11.20251 m 0,-11.036458 v -11.041667 m 0,-11.197916 v -55.520834 m 0,-11.041665 v -11.19792 m 0,-11.04166 v -11.04167 m 0,-11.19792 v -55.52083 m 0,-11.03646 v -11.04167 m 0,-11.20312 v -11.03646 m 0,-11.20313 v -55.51562 m 0,-11.04167 v -11.04166 m 0,-11.19792 v -11.04167 m 0,-11.19791 v -55.35938 m 0,-11.20312 v -11.04167 m 0,-11.19792 v -11.04166 m 0,-11.03646 v -55.52083 m 0,-11.20313 v -11.03646 m 0,-11.04166 v -11.19792 m 0,-11.04167 v -55.52083 m 0,-11.19792 v -11.04166 m 0,-11.04167 v -11.19792 m 0,-11.04166 v -55.51563 m 0,-11.04167 v -11.20312 m 0,-11.03646 v -11.20312 m 0,-11.03646 v -55.52084 m 0,-11.04166 v -11.19792 m 0,-11.04167 v -11.19791",
    transform: "matrix(0.75,0,0,0.75,141.96,765.48001)",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 189.28125,88.000005 v -61.4375 h 74.55729",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,0.00250633 H 11.19812 m 11.041667,0 h 11.197916 m 11.041667,0 h 55.52083 m 11.04167,0 h 11.19792 m 11.04166,0 h 11.03646 m 11.20313,0 h 55.52083 m 11.03646,0 h 11.04166 m 11.19792,0 h 11.04167",
    transform: "matrix(0.75,0,0,0.75,206.16,19.919995)",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 541.4375,26.562505 h 74.40104 v 61.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.00148533,0.001671 v 11.197917 m 0,11.041666 v 11.197917 m 0,11.041667 v 55.520832 m 0,11.03646 v 11.20312 m 0,11.03646 v 11.20313 m 0,11.04166 v 55.51563 m 0,11.04167 v 11.19791 m 0,11.04167 v 11.04167 m 0,11.19791 v 55.52084 m 0,11.04166 v 11.19792 m 0,11.04167 v 11.03645 m 0,11.20313 v 55.52083 m 0,11.03646 v 11.04167 m 0,11.19791 v 11.04167 m 0,11.20313 v 55.35937 m 0,11.19792 v 11.04166 m 0,11.19792 v 11.04167 m 0,11.04166 v 55.51563 m 0,11.20312 v 11.03646 m 0,11.20313 v 11.04166 m 0,11.03646 v 55.52084 m 0,11.19791 v 11.04167 m 0,11.04167 v 11.19791 m 0,11.04167 v 55.52083 m 0,11.19792 v 11.04167 m 0,11.03645 v 11.20313",
    transform: "matrix(0.75,0,0,0.75,461.88002,74.279997)",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 615.83854,1031.6823 v 61.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.87891,19.921875 -0.35938,23.636719 V 19.921875 Z m 0,0",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.87891,19.921875 v 23.636719 h -0.35938 z m 0,0",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,43.199219 -3.48047,0.359375 v -0.359375 z m 0,0",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,43.199219 v 0.359375 h -3.48047 z m 0,0",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 458.03906,40.199219 -0.48047,3.359375 v -3.359375 z m 0,0",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 458.03906,40.199219 v 3.359375 h -0.48047 z m 0,0",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 445.67969,23.878906 -3,0.359375 v -0.359375 z m 0,0",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 445.67969,23.878906 v 0.359375 h -3 z m 0,0",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,19.921875 -18.83984,0.476563 v -0.476563 z m 0,0",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,19.921875 v 0.476563 h -18.83984 z m 0,0",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 442.67969,19.921875 -0.48047,4.316406 v -4.316406 z m 0,0",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 442.67969,19.921875 v 4.316406 h -0.48047 z m 0,0",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,0.00250633 H 26.238566 M 0.639607,0.637923 H 25.759399 M 26.238566,0.00250633 V 31.518131 M 25.759399,0.637923 v 30.401042 m 0.479167,0.479166 h -5.760417 m 5.28125,-0.479166 h -4.640625 m -0.640625,0.479166 v -4.479166 m 0.640625,4 v -4 M -0.00101767,0.00250633 V 5.757715 M 0.639607,0.637923 V 5.278548 M -0.00101767,5.757715 H 4.639607",
    transform: "matrix(0.75,0,0,0.75,442.19998,19.919995)",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 590.23958,31.838547 h 4 v 0.479167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001221,-0.00103433 H -0.641846 M -7.037679,-21.282284 v 1.921875 m 0,0.640625 v 2.078125 m 0,0.479166 v 2.083334 m 0,0.479166 v 2.239584 m 0,0.479166 v 2.083334 m 0,0.479166 v 2.078125",
    transform: "matrix(0.75,0,0,0.75,458.03998,40.199995)",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 603.68229,48.000005 V 49.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,4.24e-4 h 1.921875 m 0.479167,0 h 2.078125 m 0.640625,0 h 2.078125 m 0.479166,0 h 2.083334 m 0.479166,0 h 2.239584 m 0.479166,0 h 2.083334",
    transform: "matrix(0.75,0,0,0.75,444.48001,40.319995)",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 608.16146,53.760422 h 1.91666",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 141.96094,19.921875 0.48047,23.636719 V 19.921875 Z m 0,0",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 141.96094,19.921875 v 23.636719 h 0.48047 z m 0,0",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,43.199219 3.48046,0.359375 v -0.359375 z m 0,0",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,43.199219 v 0.359375 h 3.48046 z m 0,0",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.92187,40.199219 0.35938,3.359375 v -3.359375 z m 0,0",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.92187,40.199219 v 3.359375 h 0.35938 z m 0,0",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 158.28125,23.878906 3,0.359375 v -0.359375 z m 0,0",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 158.28125,23.878906 v 0.359375 h 3 z m 0,0",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,19.921875 18.83984,0.476563 v -0.476563 z m 0,0",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,19.921875 v 0.476563 h 18.83984 z m 0,0",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 161.28125,19.921875 0.35937,4.316406 v -4.316406 z m 0,0",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 161.28125,19.921875 v 4.316406 h 0.35937 z m 0,0",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.29333e-4,0.00250633 H -26.238754 M -0.478337,0.637923 H -25.598129 M -26.238754,0.00250633 V 31.518131 m 0.640625,-30.880208 v 30.401042 m -0.640625,0.479166 h 5.760417 m -5.119792,-0.479166 h 4.640625 m 0.479167,0.479166 v -4.479166 m -0.479167,4 v -4 M 8.29333e-4,0.00250633 V 5.757715 M -0.478337,0.637923 V 5.278548 M 8.29333e-4,5.757715 H -4.478337",
    transform: "matrix(0.75,0,0,0.75,161.64,19.919995)",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 215.04167,31.838547 h -4 v 0.479167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00103433 H 0.481669 M 7.03896,-21.282284 v 1.921875 m 0,0.640625 v 2.078125 m 0,0.479166 v 2.083334 m 0,0.479166 v 2.239584 m 0,0.479166 v 2.083334 m 0,0.479166 v 2.078125",
    transform: "matrix(0.75,0,0,0.75,145.92,40.199995)",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 201.59896,48.000005 V 49.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.26e-4,4.24e-4 h -1.921875 m -0.640625,0 h -2.078125 m -0.479167,0 h -2.083333 m -0.479167,0 h -2.239583 m -0.479167,0 h -2.078125 m -0.479166,0 h -2.083334",
    transform: "matrix(0.75,0,0,0.75,159.48,40.319995)",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 196.95833,53.760422 h -1.91666",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.87891,819.83984 -0.35938,-23.64062 v 23.64062 z m 0,0",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.87891,819.83984 v -23.64062 h -0.35938 z m 0,0",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,796.55859 -3.48047,-0.35937 v 0.35937 z m 0,0",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,796.55859 v -0.35937 h -3.48047 z m 0,0",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 458.03906,799.67969 -0.48047,-3.48047 v 3.48047 z m 0,0",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 458.03906,799.67969 v -3.48047 h -0.48047 z m 0,0",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 445.67969,815.87891 -3,-0.35938 v 0.35938 z m 0,0",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 445.67969,815.87891 v -0.35938 h -3 z m 0,0",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,819.83984 -18.83984,-0.35937 v 0.35937 z m 0,0",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 461.51953,819.83984 v -0.35937 h -18.83984 z m 0,0",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 442.67969,819.83984 -0.48047,-4.32031 v 4.32031 z m 0,0",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 442.67969,819.83984 v -4.32031 h -0.48047 z m 0,0",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00101767,-1.98e-4 H 26.238566 M 0.639607,-0.479365 h 25.119792 m 0.479167,0.479167 v -31.520833 m -0.479167,31.041666 v -30.5625 m 0.479167,-0.479166 h -5.760417 m 5.28125,0.479166 h -4.640625 m -0.640625,-0.479166 v 4.640625 m 0.640625,-4.161459 v 4.161459 M -0.00101767,-1.98e-4 V -5.760615 M 0.639607,-0.479365 V -5.281448 M -0.00101767,-5.760615 H 4.639607",
    transform: "matrix(0.75,0,0,0.75,442.19998,819.83999)",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 590.23958,1087.8385 h 4 v -0.4791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001221,-4.01333e-4 H -0.641846 M -7.037679,21.11939 v -1.921875 m 0,-0.479166 v -2.239584 m 0,-0.479166 v -2.078125 m 0,-0.479167 v -2.083333 m 0,-0.640625 V 8.640224 m 0,-0.479167 V 6.077724",
    transform: "matrix(0.75,0,0,0.75,458.03998,799.67999)",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 603.68229,1071.8385 v -1.9166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,-0.00182567 h 1.921875 m 0.479167,0 h 2.078125 m 0.640625,0 h 2.078125 m 0.479166,0 h 2.083334 m 0.479166,0 h 2.239584 m 0.479166,0 h 2.083334",
    transform: "matrix(0.75,0,0,0.75,444.48001,799.55996)",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 608.16146,1066.0781 h 1.91666",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 141.96094,819.83984 0.48047,-23.64062 v 23.64062 z m 0,0",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 141.96094,819.83984 v -23.64062 h 0.48047 z m 0,0",
    id: "path79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,796.55859 3.48046,-0.35937 v 0.35937 z m 0,0",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,796.55859 v -0.35937 h 3.48046 z m 0,0",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.92187,799.67969 0.35938,-3.48047 v 3.48047 z m 0,0",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.92187,799.67969 v -3.48047 h 0.35938 z m 0,0",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 158.28125,815.87891 3,-0.35938 v 0.35938 z m 0,0",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 158.28125,815.87891 v -0.35938 h 3 z m 0,0",
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,819.83984 18.83984,-0.35937 v 0.35937 z m 0,0",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 142.44141,819.83984 v -0.35937 h 18.83984 z m 0,0",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 161.28125,819.83984 0.35937,-4.32031 v 4.32031 z m 0,0",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 161.28125,819.83984 v -4.32031 h 0.35937 z m 0,0",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.29333e-4,-1.98e-4 H -26.238754 m 25.760417,-0.479167 h -25.119792 m -0.640625,0.479167 v -31.520833 m 0.640625,31.041666 v -30.5625 m -0.640625,-0.479166 h 5.760417 m -5.119792,0.479166 h 4.640625 m 0.479167,-0.479166 v 4.640625 m -0.479167,-4.161459 v 4.161459 M 8.29333e-4,-1.98e-4 V -5.760615 M -0.478337,-0.479365 V -5.281448 M 8.29333e-4,-5.760615 H -4.478337",
    transform: "matrix(0.75,0,0,0.75,161.64,819.83999)",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 215.04167,1087.8385 h -4 v -0.4791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-4.01333e-4 H 0.481669 M 7.03896,21.11939 v -1.921875 m 0,-0.479166 v -2.239584 m 0,-0.479166 v -2.078125 m 0,-0.479167 v -2.083333 m 0,-0.640625 V 8.640224 m 0,-0.479167 V 6.077724",
    transform: "matrix(0.75,0,0,0.75,145.92,799.67999)",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 201.59896,1071.8385 v -1.9166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.26e-4,-0.00182567 h -1.921875 m -0.640625,0 h -2.078125 m -0.479167,0 h -2.083333 m -0.479167,0 h -2.239583 m -0.479167,0 h -2.078125 m -0.479166,0 h -2.083334",
    transform: "matrix(0.75,0,0,0.75,159.48,799.55996)",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 196.95833,1066.0781 h -1.91666",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 418.07812,774.40105 V 984.16146 H 404.95833 V 774.40105 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001862,0.001023 -0.958333,-1.28125 -1.28125,-0.958333 -1.276042,-0.640625 -1.442708,-0.479167 -1.598959,-0.161458 -1.598958,0.161458 -1.442708,0.479167 -1.28125,0.640625 -1.276042,0.958333 -0.963542,1.28125",
    transform: "matrix(0.75,0,0,0.75,313.55999,580.80001)",
    id: "path97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00165767,0.00149067 0.961884,1.277532 2.237926,2.241074 3.519176,2.881699 4.961884,3.360866 6.560842,3.522324 8.159801,3.360866 9.602509,2.881699 10.878551,2.241074 12.159801,1.277532 13.118134,0.00149067",
    transform: "matrix(0.75,0,0,0.75,303.71999,738.11998)",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 411.52083,774.40105 V 984.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path99"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g99"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 316.32559,
    y: 629.76477,
    id: "use99"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14617.999,-7386.3228 c 8.801,3.8617 13.291,13.1117 13.291,27.6604 0,4.1311 -0.539,8.1724 -1.437,12.2137 l -5.747,21.1944 c -6.287,23.5293 -18.59,39.1556 -37.001,47.0586 -9.34,3.8617 -20.027,5.7476 -31.971,5.7476 h -40.952 c -7.005,0 -10.417,-3.4126 -10.417,-10.4175 0,-7.1845 3.412,-10.7768 10.417,-10.7768 h 46.7 c 9.07,0 17.602,-2.9636 25.505,-8.9807 8.082,-6.1966 13.381,-13.7404 15.806,-22.6312 l 5.747,-21.1944 c 0.898,-4.3107 1.437,-8.2622 1.437,-11.8545 0,-13.1117 -8.621,-19.7574 -25.864,-19.7574 h -19.039 c -7.184,0 -10.777,-3.4127 -10.777,-10.4176 0,-7.1845 3.593,-10.7768 10.777,-10.7768 h 24.787 c 12.662,0 23.529,-5.2087 32.689,-15.8059 4.311,-4.7598 7.185,-10.0584 8.622,-15.806 0.718,-3.5922 1.077,-6.6457 1.077,-9.3399 0,-14.8181 -8.531,-22.272 -25.505,-22.272 h -40.952 c -7.004,0 -10.417,-3.5923 -10.417,-10.7768 0,-6.9151 3.413,-10.4176 10.417,-10.4176 h 46.7 c 16.524,0 28.558,7.3642 36.282,21.9128 3.592,6.7355 5.388,13.6506 5.388,20.8352 0,3.4126 -0.539,6.7355 -1.437,10.0583 -6.017,22.9905 -17.422,37.8984 -34.126,44.5441 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path100"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g100"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 316.32559,
    y: 636.31323,
    id: "use100"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14711.038,-7293.6424 c 21.734,0 35.654,-10.5074 41.671,-31.6119 l 5.747,-21.1944 c 0.898,-4.3107 1.437,-8.2622 1.437,-11.8545 0,-13.1117 -8.801,-19.7574 -26.223,-19.7574 h -32.69 l -14.01,52.8063 c -0.988,3.1432 -1.437,5.7476 -1.437,7.9029 0,7.1846 2.335,12.9322 7.185,17.2429 5.029,4.3107 11.136,6.4661 18.32,6.4661 z m -5.388,21.1943 c -15.088,0 -27.122,-7.7233 -35.923,-23.3497 -3.861,-6.6457 -5.747,-13.6506 -5.747,-20.8351 0,-2.8738 0.359,-5.568 1.077,-8.2622 l 16.884,-63.5831 c 6.466,-23.7089 16.974,-43.2868 31.612,-58.9131 16.704,-17.6919 38.437,-29.6362 65.02,-35.9226 0.718,-0.1796 1.527,-0.3593 2.515,-0.3593 7.184,0 10.776,3.5025 10.776,10.4176 0,6.017 -2.424,9.3399 -7.184,10.0583 -11.765,1.7064 -23.619,6.1069 -35.564,13.2914 -21.374,12.9322 -35.024,29.8158 -40.951,50.6509 h 31.252 c 12.214,0 22.272,3.8617 30.175,11.4953 8.083,7.7233 12.214,17.6021 12.214,29.8158 0,4.1311 -0.539,7.9029 -1.437,11.4952 l -5.748,21.1944 c -7.004,24.6968 -18.949,40.5027 -35.922,47.4178 -8.891,3.5923 -19.937,5.3884 -33.049,5.3884 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path101"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g101"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 316.32559,
    y: 642.86169,
    id: "use101"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14929.179,-7376.6237 -61.069,99.1465 c -2.155,3.4126 -5.209,5.0291 -8.981,5.0291 -2.873,0 -5.388,-1.0776 -7.543,-3.233 -2.156,-2.1554 -3.144,-4.6699 -2.874,-7.5437 l 6.825,-190.39 c 0.18,-6.6457 3.772,-10.0584 10.777,-10.0584 7.364,0 10.956,3.7719 10.777,11.1361 l -6.107,150.1566 56.758,-92.6804 c 2.155,-3.5923 5.029,-5.3884 8.621,-5.3884 6.915,0 10.597,3.4126 11.136,10.0583 l 7.185,89.4474 77.233,-156.9819 c 1.886,-3.7719 5.03,-5.7477 9.34,-5.7477 7.185,0 10.777,3.4127 10.777,10.0584 0,1.9757 -0.359,3.5922 -1.078,5.0291 l -94.476,190.39 c -1.976,3.8617 -5.029,5.7476 -9.34,5.7476 -6.736,0 -10.328,-3.233 -10.777,-9.6991 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path102"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g102"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 316.56223,
    y: 661.92157,
    id: "use102"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15341.121,-7299.1206 c 6.916,0 10.418,3.5923 10.418,10.7768 0,7.0049 -3.502,10.4175 -10.418,10.4175 h -90.525 c -3.143,0 -5.568,-0.898 -7.184,-2.8738 -1.437,-2.1553 -1.706,-4.6699 -0.719,-7.5437 l 51.729,-192.9046 c 1.437,-5.2088 4.76,-7.903 10.058,-7.903 6.915,0 10.418,3.5025 10.418,10.4176 0,1.2573 0,2.1554 0,2.8738 l -47.418,176.7394 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path103"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g103"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 316.56223,
    y: 668.47003,
    id: "use103"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15498.103,-7383.5388 h -57.476 l -22.631,84.4182 h 73.641 c 6.915,0 10.418,3.5923 10.418,10.7768 0,7.0049 -3.503,10.4175 -10.418,10.4175 h -90.525 c -3.143,0 -5.568,-0.898 -7.184,-2.8738 -1.437,-2.1553 -1.707,-4.6699 -0.719,-7.5437 l 51.01,-190.39 c 1.617,-6.9151 6.197,-10.4176 13.651,-10.4176 h 84.418 c 7.185,0 10.777,3.5025 10.777,10.4176 0,7.1845 -3.592,10.7768 -10.777,10.7768 h -79.03 l -16.883,63.2238 h 51.728 c 6.915,0 10.418,3.5923 10.418,10.7768 0,7.0049 -3.503,10.4176 -10.418,10.4176 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path104"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g104"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 316.56223,
    y: 675.01849,
    id: "use104"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15594.825,-7478.7338 c 1.617,-6.9151 6.197,-10.4176 13.651,-10.4176 h 65.738 c 10.957,0 20.656,4.67 29.097,14.0099 8.352,9.1602 12.573,19.3084 12.573,30.5342 0,2.6942 -0.359,5.3884 -1.077,8.2622 l -28.379,105.6126 c -9.61,35.2042 -32.6,52.8062 -68.972,52.8062 h -65.738 c -3.143,0 -5.568,-0.898 -7.185,-2.8738 -1.437,-2.1553 -1.706,-4.6699 -0.718,-7.5437 z m 19.039,10.7768 -45.262,168.8364 h 54.602 c 8.801,0 17.333,-2.9636 25.505,-8.9807 8.083,-6.1966 13.381,-13.7404 15.806,-22.6312 l 28.379,-105.6126 c 0.718,-2.8738 1.078,-5.4782 1.078,-7.903 0,-7.1845 -2.515,-12.9321 -7.544,-17.2428 -4.85,-4.3107 -10.777,-6.4661 -17.962,-6.4661 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 434.71875,882.5625 v 31.51563 H 421.4375 V 882.5625 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 347.52083,96.479172 V 85.598964",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 347.52083,85.437505 1.11979,-0.796875 1.1198,-1.119791 0.80208,-1.119792 0.63542,-1.442708 0.32291,-1.4375 0.16146,-1.442709",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 351.83854,78.07813 V 60.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,6.31333e-4 -0.15916,-1.759785 -0.638326,-3.358744 -1.44041,-4.801452 l -1.119791,-1.276042 -1.28125,-1.125 -1.4375,-0.796875 -1.598959,-0.479166 -1.760416,-0.161459",
    transform: "matrix(0.75,0,0,0.75,263.75999,45.479995)",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 343.04167,51.838547 H 290.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,5.33333e-6 -1.757915,0.161464 -3.362081,0.64063 l -1.4375,0.796875 -1.28125,1.125 -1.119792,1.276042 -0.796875,1.442708 -0.484375,1.598959 -0.15625,1.760416",
    transform: "matrix(0.75,0,0,0.75,217.92,38.999996)",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 281.92187,60.64063 v 17.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 281.92187,78.07813 0.15625,1.442709 0.32292,1.4375 0.64063,1.442708 0.79687,1.119792 1.11979,1.119791 1.11979,0.796875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 286.07812,85.598964 V 96.479172",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 286.07812,96.479172 -0.64062,2.239583 -0.63542,2.239585",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 284.95833,100.95834 284,104.31771 l -0.64063,3.36459 -0.64062,3.51562 -0.31771,3.52084 -0.32292,3.52083 v 3.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 282.07812,121.76042 v 3.52084 l 0.32292,3.52083 0.31771,3.51562 0.64062,3.52084 0.64063,3.35937 0.95833,3.36458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 284.80208,142.5625 0.79688,2.875 0.96354,2.88021 1.27604,2.72396 1.28125,2.71875 1.44271,2.55729 1.59896,2.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 292.31771,158.71875 1.60416,2.23959 1.76042,2.23958 2.07813,2.08333 2.07812,1.91667 2.23958,1.76042 2.40105,1.60416",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.31771,170.5625 3.84375,1.91667 2.07812,0.64063 2.23959,0.47916 2.08333,0.32292 2.23958,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.80208,174.07813 2.23959,-0.15625 2.07812,-0.32292 2.23958,-0.47916 2.07813,-0.64063 3.84375,-1.91667",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 329.28125,170.5625 2.40104,-1.60416 2.23958,-1.76042 2.07813,-1.91667 2.07812,-2.08333 1.76042,-2.23958 1.59896,-2.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 341.4375,158.88021 1.60417,-2.5625 1.4375,-2.55729 1.28125,-2.71875 1.28125,-2.72396 0.95833,-2.88021 0.80208,-2.875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.80208,142.5625 0.95834,-3.36458 0.64062,-3.35937 0.64063,-3.52084 0.3177,-3.51562 0.32292,-3.52083 v -3.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 351.68229,121.76042 v -3.52083 l -0.32292,-3.52083 -0.3177,-3.52084 -0.64063,-3.51562 -0.64062,-3.36459 -0.95834,-3.35937",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 348.80208,100.95834 -1.28125,-4.479168",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 301.59896,86.880214 -1.11979,1.28125 -0.95834,1.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 299.52083,89.598964 -2.08333,3.203125 -1.59896,3.359375 -1.4375,3.520833 -1.11979,3.515623",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.28125,103.19792 -0.80208,3.04167 -0.64063,3.04167 -0.47917,3.19791 -0.3177,3.04167 -0.32292,3.04167 v 3.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 290.71875,121.76042 v 3.19792 l 0.32292,3.04166 0.3177,3.04167 0.47917,3.19792 0.64063,3.04166 0.80208,3.03646",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.28125,140.31771 1.11979,3.52084 1.4375,3.52083 1.59896,3.35937 2.08333,3.20313",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 299.52083,153.92188 1.28125,1.76042 1.4375,1.7552 1.44271,1.60417 1.75521,1.4375 1.76042,1.44271 1.76041,1.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 308.80208,163.19792 1.91667,0.96354 1.92187,0.64063 2.07813,0.47916 2.08333,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 316.80208,165.4375 2.07813,-0.15625 2.07812,-0.47916 1.92188,-0.64063 1.92187,-0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 324.80208,163.19792 1.76042,-1.27604 1.75521,-1.44271 1.76041,-1.4375 1.44271,-1.60417 1.4375,-1.7552 1.28125,-1.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 334.07812,153.92188 2.08334,-3.20313 1.59896,-3.35937 1.4375,-3.52083 1.11979,-3.52084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.47917,140.31771 0.80208,-3.03646 0.64062,-3.04166 0.47917,-3.19792 0.31771,-3.04167 0.32292,-3.04166 v -3.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 343.04167,121.76042 v -3.19791 l -0.32292,-3.04167 -0.31771,-3.04167 -0.47917,-3.19791 -0.64062,-3.04167 -0.80208,-3.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 340.31771,103.19792 -1.11979,-3.515623 -1.4375,-3.520833 -1.59896,-3.359375 -2.08334,-3.203125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 334.23958,89.598964 -0.95833,-1.4375 -1.11979,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00187167 0.160614,1.11792 0.478322,2.39917 0.957489,3.357503 1.759572,4.321045 2.717906,5.11792 l 0.963541,0.484375 1.276042,0.317708 1.125,0.161459",
    transform: "matrix(0.75,0,0,0.75,213.36001,58.559998)",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 284.47917,78.07813 V 60.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.002502,0.00250433 -1.125,0.15624967 -1.276042,0.322917 -0.963541,0.479167 -0.958334,0.796875 -0.802083,0.963541 -0.479167,0.958334 -0.317708,1.28125 -0.161458,1.119791",
    transform: "matrix(0.75,0,0,0.75,217.92,40.919997)",
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 290.5625,54.401047 h 52.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,6.31333e-4 -0.161662,-1.11916 -0.47937,-2.40041 -0.958537,-3.358744 -1.76062,-4.322285 -2.718953,-5.11916 -3.682495,-5.598327 -4.958537,-5.921244 -6.078328,-6.077494",
    transform: "matrix(0.75,0,0,0.75,261.84,45.479995)",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 349.11979,60.64063 v 17.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,0.00145967 1.121449,-0.159999 2.397491,-0.477707 3.361033,-0.962082 4.319366,-1.758957 5.121449,-2.722499 5.600616,-3.680832 5.918324,-4.962082 6.079783,-6.081874",
    transform: "matrix(0.75,0,0,0.75,257.28001,63.119999)",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 343.04167,84.161464 H 290.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 343.04167,86.718755 h 1.11979 l 1.11979,-0.317708 1.11979,-0.322917 1.11979,-0.640625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 343.04167,86.718755 H 290.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 286.07812,85.437505 1.1198,0.640625 1.11979,0.322917 1.11979,0.317708 h 1.125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,-0.00166833 -1.4375,-2.079793 -3.359375,-3.84021 -5.4375,-5.27771 l -2.244792,-1.28125 -2.395833,-0.963542 -2.5625,-0.479166 -2.557292,-0.15625 -2.5625,0.15625 -2.557291,0.479166 -2.401042,0.963542 -2.239583,1.28125 -2.083334,1.4375 -1.916666,1.760417 -1.442709,2.07812467",
    transform: "matrix(0.75,0,0,0.75,249,117.72)",
    id: "path153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,0.00125633 0.160411,0.95959 0.639577,1.917923 1.280202,2.558548 2.238536,3.037715 3.202077,3.199173 4.160411,3.037715 5.118744,2.558548 5.759369,1.917923 6.238536,0.95959 6.399994,0.00125633 6.238536,-0.962285 5.759369,-1.920619 5.118744,-2.561244 4.160411,-3.04041 3.202077,-3.201869 2.238536,-3.04041 1.280202,-2.561244 0.639577,-1.920619 0.160411,-0.962285 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,235.2,51.959995)",
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 413.11979,356.80209 V 566.5625 H 400 V 356.80209 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,0.00210067 -0.958537,-1.279149 l -1.28125,-0.958334 -1.28125,-0.640625 -1.4375,-0.484375 -1.598958,-0.15625 -1.604167,0.15625 -1.4375,0.484375 -1.28125,0.640625 -1.28125,0.958334 -0.958333,1.28124967",
    transform: "matrix(0.75,0,0,0.75,309.84,267.59999)",
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,0.00250733 0.958333,1.27604167 1.28125,0.963542 1.28125,0.635416 1.4375,0.484375 1.604167,0.15625 1.598958,-0.15625 1.4375,-0.484375 1.28125,-0.635416 1.28125,-0.963542 0.958334,-1.27604167",
    transform: "matrix(0.75,0,0,0.75,300,424.91999)",
    id: "path157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 406.5625,356.80209 V 566.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path158"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g158"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 312.60233,
    y: 316.56223,
    id: "use158"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7417.3062,-7300.7371 c 8.801,3.8617 13.2914,13.1117 13.2914,27.6604 0,4.1311 -0.5389,8.1724 -1.4369,12.2137 l -5.7477,21.1944 c -6.2864,23.5293 -18.5899,39.1556 -37.0003,47.0586 -9.3399,3.8617 -20.0269,5.7476 -31.9711,5.7476 h -40.9518 c -7.005,0 -10.4176,-3.4126 -10.4176,-10.4175 0,-7.1846 3.4126,-10.7768 10.4176,-10.7768 h 46.6994 c 9.0705,0 17.6021,-2.9636 25.5051,-8.9807 8.0826,-6.1966 13.3811,-13.7404 15.8059,-22.6312 l 5.7476,-21.1944 c 0.8981,-4.3107 1.4369,-8.2622 1.4369,-11.8545 0,-13.1117 -8.6214,-19.7574 -25.8643,-19.7574 h -19.0389 c -7.1846,0 -10.7768,-3.4127 -10.7768,-10.4176 0,-7.1845 3.5922,-10.7768 10.7768,-10.7768 h 24.7866 c 12.6627,0 23.5293,-5.2088 32.6896,-15.8059 4.3107,-4.7598 7.1845,-10.0584 8.6214,-15.806 0.7185,-3.5923 1.0777,-6.6457 1.0777,-9.3399 0,-14.8181 -8.5316,-22.272 -25.5051,-22.272 h -40.9518 c -7.0049,0 -10.4176,-3.5923 -10.4176,-10.7768 0,-6.9151 3.4127,-10.4176 10.4176,-10.4176 h 46.6994 c 16.5244,0 28.5585,7.3642 36.2819,21.9128 3.5923,6.7355 5.3884,13.6506 5.3884,20.8352 0,3.4126 -0.5388,6.7355 -1.4369,10.0583 -6.0171,22.9905 -17.4225,37.8984 -34.1265,44.5441 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path159"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g159"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 312.60233,
    y: 323.11066,
    id: "use159"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7510.3458,-7208.0567 c 21.7332,0 35.6532,-10.5074 41.6703,-31.6119 l 5.7476,-21.1944 c 0.8981,-4.3107 1.4369,-8.2622 1.4369,-11.8545 0,-13.1117 -8.801,-19.7574 -26.2235,-19.7574 h -32.6896 l -14.0099,52.8063 c -0.9878,3.1432 -1.4369,5.7476 -1.4369,7.9029 0,7.1846 2.335,12.9322 7.1846,17.2429 5.0291,4.3107 11.136,6.4661 18.3205,6.4661 z m -5.3884,21.1943 c -15.0875,0 -27.1216,-7.7233 -35.9226,-23.3497 -3.8617,-6.6457 -5.7476,-13.6506 -5.7476,-20.8351 0,-2.8738 0.3592,-5.568 1.0776,-8.2622 l 16.8837,-63.5831 c 6.466,-23.7089 16.9734,-43.2868 31.6119,-58.9131 16.704,-17.6919 38.4372,-29.6362 65.02,-35.9227 0.7184,-0.1796 1.5267,-0.3592 2.5146,-0.3592 7.1845,0 10.7767,3.5025 10.7767,10.4176 0,6.017 -2.4247,9.3399 -7.1845,10.0583 -11.7646,1.7064 -23.6191,6.1069 -35.5634,13.2914 -21.374,12.9321 -35.0246,29.8158 -40.9518,50.6509 h 31.2527 c 12.2137,0 22.272,3.8617 30.175,11.4953 8.0826,7.7233 12.2137,17.6021 12.2137,29.8158 0,4.1311 -0.5388,7.9029 -1.4369,11.4952 l -5.7476,21.1944 c -7.0049,24.6968 -18.9492,40.5027 -35.9227,47.4178 -8.8908,3.5923 -19.937,5.3884 -33.0488,5.3884 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path160"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g160"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 312.60233,
    y: 329.65912,
    id: "use160"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7728.486,-7291.038 -61.0685,99.1465 c -2.1553,3.4126 -5.2087,5.0291 -8.9806,5.0291 -2.8738,0 -5.3884,-1.0777 -7.5438,-3.233 -2.1553,-2.1554 -3.1432,-4.67 -2.8738,-7.5438 l 6.8253,-190.3899 c 0.1796,-6.6457 3.7719,-10.0584 10.7768,-10.0584 7.3641,0 10.9564,3.7719 10.7768,11.136 l -6.1068,150.1567 56.7577,-92.6804 c 2.1554,-3.5923 5.0292,-5.3884 8.6215,-5.3884 6.9151,0 10.5971,3.4126 11.136,10.0583 l 7.1845,89.4474 77.2337,-156.982 c 1.8859,-3.7718 5.0291,-5.7476 9.3399,-5.7476 7.1845,0 10.7767,3.4127 10.7767,10.0584 0,1.9757 -0.3592,3.5922 -1.0776,5.0291 l -94.4766,190.39 c -1.9757,3.8617 -5.0291,5.7476 -9.3399,5.7476 -6.7355,0 -10.3277,-3.233 -10.7767,-9.6991 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path161"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g161"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 312.83893,
    y: 348.72159,
    id: "use161"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8140.5187,-7213.5349 c 6.9151,0 10.4175,3.5922 10.4175,10.7768 0,7.0049 -3.5024,10.4175 -10.4175,10.4175 h -90.5251 c -3.1432,0 -5.568,-0.898 -7.1845,-2.8738 -1.4369,-2.1553 -1.7063,-4.6699 -0.7185,-7.5437 l 51.7286,-192.9046 c 1.4369,-5.2088 4.7598,-7.903 10.0584,-7.903 6.9151,0 10.4175,3.5025 10.4175,10.4176 0,1.2573 0,2.1553 0,2.8738 l -47.4178,176.7394 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path162"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g162"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 312.83893,
    y: 355.27005,
    id: "use162"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8297.5006,-7297.9531 h -57.4762 l -22.6313,84.4182 h 73.6414 c 6.9151,0 10.4176,3.5922 10.4176,10.7768 0,7.0049 -3.5025,10.4175 -10.4176,10.4175 h -90.525 c -3.1433,0 -5.568,-0.898 -7.1846,-2.8738 -1.4369,-2.1553 -1.7063,-4.6699 -0.7184,-7.5437 l 51.0101,-190.39 c 1.6166,-6.9151 6.1967,-10.4176 13.6506,-10.4176 h 84.4182 c 7.1846,0 10.7768,3.5025 10.7768,10.4176 0,7.1845 -3.5922,10.7768 -10.7768,10.7768 h -79.0298 l -16.8836,63.2238 h 51.7286 c 6.9151,0 10.4176,3.5923 10.4176,10.7768 0,7.0049 -3.5025,10.4176 -10.4176,10.4176 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path163"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g163"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 312.83893,
    y: 361.81851,
    id: "use163"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 8394.2223,-7393.1481 c 1.6165,-6.9151 6.1966,-10.4176 13.6506,-10.4176 h 65.7384 c 10.9564,0 20.6555,4.67 29.0974,14.0098 8.352,9.1603 12.5729,19.3085 12.5729,30.5343 0,2.6942 -0.3592,5.3884 -1.0777,8.2622 l -28.3789,105.6125 c -9.6093,35.2042 -32.5998,52.8063 -68.9714,52.8063 h -65.7385 c -3.1432,0 -5.568,-0.898 -7.1845,-2.8738 -1.4369,-2.1553 -1.7063,-4.6699 -0.7185,-7.5437 z m 19.039,10.7768 -45.2625,168.8364 h 54.6024 c 8.801,0 17.3327,-2.9636 25.5051,-8.9807 8.0825,-6.1966 13.3811,-13.7404 15.8059,-22.6313 l 28.3789,-105.6125 c 0.7184,-2.8738 1.0777,-5.4782 1.0777,-7.903 0,-7.1845 -2.5146,-12.9321 -7.5438,-17.2428 -4.8495,-4.3108 -10.7768,-6.4661 -17.9613,-6.4661 z m 0,0",
    transform: "matrix(0,0.0434963,-0.0434963,0,0,-4e-6)",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 429.92187,465.1198 v 31.35937 h -13.4427 V 465.1198 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.16146,598.23959 v 0.32291 l 0.15625,0.31771 0.32291,0.16146 h 0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 444.95833,599.04167 H 583.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 583.04167,599.04167 h 0.3177 l 0.32292,-0.16146 0.15625,-0.31771 v -0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 583.83854,598.23959 V 267.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 583.83854,267.6823 v -0.32292 l -0.15625,-0.31771 -0.32292,-0.16146 h -0.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 583.04167,266.88021 H 444.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.95833,266.88021 h -0.31771 l -0.32291,0.16146 -0.15625,0.31771 v 0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 444,267.6823 V 598.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 573.4375,537.76042 0.64062,-0.16146 0.48438,-0.31771 0.31771,-0.47916 0.16146,-0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 575.19792,536.16146 V 275.6823 H 452.80208 v 241.27604",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 573.4375,537.92188 h -99.67708 l -20.95834,-20.96354 h 17.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 473.76042,537.92188 V 520.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 473.59896,520.31771 -0.16146,-0.79687 -0.31771,-0.95834 -0.47917,-0.64062 L 472,517.4375 l -0.95833,-0.3177 -0.80209,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 470.23958,534.23959 h -3.52083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.71875,534.40105 -0.79688,0.16145 -0.80208,0.31771 -0.80208,0.47917 -0.47917,0.64062 -0.31771,0.95834 -0.16146,0.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 463.19792,537.76042 v 48.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 463.35937,586.40105 0.16146,0.79687 0.31771,0.80208 0.47917,0.80209 0.80208,0.47916 0.80208,0.31771 0.79688,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 466.71875,589.92188 H 562.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 562.5625,589.76042 0.79687,-0.16146 0.95834,-0.31771 0.64062,-0.47916 0.47917,-0.80209 0.32292,-0.80208 0.16145,-0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 566.07812,586.40105 V 537.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 444,556.16146 V 503.6823 h -3.52083 v 52.47916 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.47917,556.16146 v 7.03646 h 4.47916 v -7.03646 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 440.47917,496.80209 v 6.88021 h 4.47916 v -6.88021 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00187167 1.118947,-0.158122 l 1.28125,-0.322916 0.958334,-0.479167 0.963541,-0.802083 0.796875,-0.958334 0.479167,-0.958333 0.322917,-1.28125 0.161458,-1.119792",
    transform: "matrix(0.75,0,0,0.75,192.36001,109.56)",
    id: "path189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 256.47917,146.07813 H 219.68229",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,5.33333e-6 0.160411,1.119797 0.478119,2.401047 0.962494,3.35938 1.759369,4.317714 2.717702,5.119797 3.681244,5.598964 4.962494,5.92188 6.082286,6.07813",
    transform: "matrix(0.75,0,0,0.75,160.2,105)",
    id: "path191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 213.59896,140 V 57.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,-0.001453 -1.117493,0.160005 -2.398743,0.477714 -3.362285,0.962089 -4.320618,1.758964 -5.117493,2.722505 -5.601868,3.680839 -5.919576,4.962089 -6.081035,6.08188",
    transform: "matrix(0.75,0,0,0.75,164.75999,38.879996)",
    id: "path193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 219.68229,51.682297 h 36.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00188233 -0.158956,-1.117909 -0.481873,-2.399159 -0.96104,-3.357493 -1.757915,-4.321034 -2.721456,-5.117909 -3.67979,-5.602284 -4.96104,-5.919993 -6.080831,-6.081451",
    transform: "matrix(0.75,0,0,0.75,196.92,43.439995)",
    id: "path195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 262.5625,57.92188 V 140",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path196"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g196"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 171.84039,
    y: 63.356262,
    id: "use196"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g197"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 171.84039,
    y: 71.554619,
    id: "use197"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g198"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 171.84039,
    y: 79.606575,
    id: "use198"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 452.80208,187.04167 v 2.71875 H 592.64062 V 49.92188 H 452.80208 v 2.557292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 452.80208,187.04167 H 583.83854",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00148533,0.001679 1.118306,-0.159779 2.399556,-0.477488 3.35789,-0.961863 4.321431,-1.758738 5.118306,-2.722279 5.597473,-3.680613 5.92039,-4.961863 6.081848,-6.081654",
    transform: "matrix(0.75,0,0,0.75,437.88002,140.27999)",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 590.07812,180.95834 V 58.562505",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001892,0.00250433 -0.159566,-1.122496 -0.482483,-2.398537 -0.96165,-3.362079 -1.758525,-4.320412 -2.722066,-5.122496 -3.6804,-5.601662 -4.96165,-5.919371 -6.081441,-6.080829",
    transform: "matrix(0.75,0,0,0.75,442.43999,43.919997)",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 583.83854,52.479172 H 452.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,2.08667e-4 1.28186,-0.958125 2.240193,-2.077916 3.042277,-3.520625 3.521443,-4.958125 3.677693,-6.562291 3.521443,-8.16125 3.042277,-9.59875 2.240193,-11.041458 1.28186,-12.16125 6.1e-4,-13.119583",
    transform: "matrix(0.75,0,0,0.75,339.48001,140.16)",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,-0.00249667 1.28186,-0.96083 2.240193,-2.080622 3.042277,-3.518122 3.521443,-4.96083 3.677693,-6.559788 3.521443,-8.158747 3.042277,-9.601455 2.240193,-11.038955 1.28186,-12.158747 6.1e-4,-13.122288",
    transform: "matrix(0.75,0,0,0.75,339.48001,130.08)",
    id: "path219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,5.33333e-6 1.28186,-0.958328 2.240193,-2.07812 l 0.802084,-1.442708 0.479166,-1.4375 0.15625,-1.604167 -0.15625,-1.598958 -0.479166,-1.4375 -0.802084,-1.442708 -0.958333,-1.119792 -1.28125,-0.958333",
    transform: "matrix(0.75,0,0,0.75,339.48001,120)",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,0.00250733 1.28186,-0.961034 2.240193,-2.080826 3.042277,-3.518326 3.521443,-4.961034 3.677693,-6.559993 3.521443,-8.158951 3.042277,-9.601659 2.240193,-11.039159 1.28186,-12.158951 6.1e-4,-13.122493",
    transform: "matrix(0.75,0,0,0.75,339.48001,109.92)",
    id: "path221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,-1.98e-4 1.28125,-0.958333 0.958333,-1.119792 0.802084,-1.442708 0.479166,-1.4375 0.15625,-1.598959 -0.15625,-1.604166 -0.479166,-1.4375 L 2.240193,-11.041865 1.28186,-12.161656 6.1e-4,-13.11999",
    transform: "matrix(0.75,0,0,0.75,339.48001,99.839992)",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,0.002297 1.28125,-0.963542 0.958333,-1.119791 0.802084,-1.4375 0.479166,-1.442709 0.15625,-1.598958 L 3.521443,-8.159161 3.042277,-9.60187 2.240193,-11.03937 1.28186,-12.159161 6.1e-4,-13.117495",
    transform: "matrix(0.75,0,0,0.75,339.48001,89.759996)",
    id: "path223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,-0.00187167 1.28186,-0.960205 2.240193,-2.079997 3.042277,-3.517497 3.521443,-4.960205 3.677693,-6.559163 3.521443,-8.158122 3.042277,-9.60083 2.240193,-11.03833 1.28186,-12.158122 6.1e-4,-13.121663",
    transform: "matrix(0.75,0,0,0.75,339.48001,79.559998)",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,6.31333e-4 1.28186,-0.957702 2.240193,-2.077494 3.042277,-3.520202 3.521443,-4.957702 3.677693,-6.561869 3.521443,-8.160827 3.042277,-9.598327 2.240193,-11.041035 1.28186,-12.160827 6.1e-4,-13.11916",
    transform: "matrix(0.75,0,0,0.75,339.48001,69.479995)",
    id: "path225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.1e-4,-0.002075 1.28186,-0.960408 2.240193,-2.0802 3.042277,-3.5177 3.521443,-4.960408 3.677693,-6.559367 3.521443,-8.158325 3.042277,-9.601033 2.240193,-11.038533 1.28186,-12.158325 6.1e-4,-13.121867",
    transform: "matrix(0.75,0,0,0.75,339.48001,59.399994)",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6.1e-4,4.2e-4 1.28125,-0.958333 0.958333,-1.119792 0.802084,-1.442708 0.479166,-1.4375 0.15625,-1.604167 -0.15625,-1.598958 -0.479166,-1.4375 -0.802084,-1.442709 -0.958333,-1.119791 -1.28125,-0.958334",
    transform: "matrix(0.75,0,0,0.75,339.48001,49.319998)",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-8.24e-4 1.76062,-0.162282 l 1.760417,-0.635417 1.598958,-0.802083 1.28125,-1.28125 1.119792,-1.4375 0.640625,-1.598959 0.479166,-1.760416 v -1.921875 l -0.479166,-1.760417 -0.640625,-1.598958 -1.119792,-1.442709 -1.28125,-1.276041 -1.598958,-0.802084 -1.760417,-0.640625 -1.760416667,-0.161458 -1.760416333,0.161458 -1.760417,0.640625 -1.598958,0.802084 -1.28125,1.276041 -1.119792,1.442709 -0.640625,1.598958 -0.479167,1.760417 v 1.921875 l 0.479167,1.760416 0.640625,1.598959 1.119792,1.4375 1.28125,1.28125 1.598958,0.802083 1.760417,0.635417 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,389.16,96.359993)",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 525.11979,125.92188 -12.47917,-12.32292 m 0,12.32292 12.47917,-12.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.51953,41.039062 -0.12109,1.199219 v -1.558593 z m 0,0",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.51953,41.039062 v 0.722657 l -0.12109,0.476562 z m 0,0",
    id: "path231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.39844,40.679688 -0.11719,1.679687 v -1.800781 z m 0,0",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.39844,40.679688 v 1.558593 l -0.11719,0.121094 z m 0,0",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.28125,40.558594 -0.12109,2.042968 v -2.28125 z m 0,0",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.28125,40.558594 v 1.800781 l -0.12109,0.242187 z m 0,0",
    id: "path235"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.16016,41.519531 -0.1211,1.082031 v -0.960937 z m 0,0",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.16016,41.519531 v 1.082031 h -0.1211 z m 0,0",
    id: "path237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.16016,40.320312 -0.1211,1.078126 v -1.078126 z m 0,0",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.16016,40.320312 v 1.199219 l -0.1211,-0.121093 z m 0,0",
    id: "path239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.03906,40.199219 -0.23828,0.480469 v -0.601563 z m 0,0",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 302.03906,40.199219 v 0.722656 l -0.23828,-0.242187 z m 0,0",
    id: "path241"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.80078,39.960938 -0.12109,0.597656 v -0.597656 z m 0,0",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.80078,39.960938 v 0.597656 h -0.12109 z m 0,0",
    id: "path243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.67969,39.960938 -0.35938,0.238281 v -0.238281 z m 0,0",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.67969,39.960938 v 0.597656 l -0.35938,-0.359375 z m 0,0",
    id: "path245"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.67969,39.960938 h -0.48047 V 39.71875 Z m 0,0",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.32031,39.960938 -0.48047,0.117187 v -0.117187 z m 0,0",
    id: "path247"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.32031,39.960938 v 0.238281 l -0.48047,-0.121094 z m 0,0",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.19922,39.71875 -0.35938,0.242188 V 39.71875 Z m 0,0",
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 301.19922,39.71875 v 0.242188 h -0.35938 z m 0,0",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.83984,39.960938 -0.48047,0.238281 v -0.238281 z m 0,0",
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.83984,39.960938 v 0.117187 l -0.48047,0.121094 z m 0,0",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.83984,39.71875 -0.60156,0.242188 v -0.121094 z m 0,0",
    id: "path253"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.83984,39.71875 v 0.242188 h -0.60156 z m 0,0",
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.35937,39.960938 -0.48046,0.597656 v -0.597656 z m 0,0",
    id: "path255"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.35937,39.960938 v 0.238281 l -0.48046,0.359375 z m 0,0",
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.23828,39.839844 -0.35937,0.121094 z m 0,0",
    id: "path257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 300.23828,39.839844 v 0.121094 h -0.35937 z m 0,0",
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.87891,39.960938 -0.11719,0.71875 v -0.71875 z m 0,0",
    id: "path259"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.87891,39.960938 v 0.597656 l -0.11719,0.121094 z m 0,0",
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.76172,39.960938 -0.24219,0.960937 v -0.722656 z m 0,0",
    id: "path261"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.76172,39.960938 v 0.71875 l -0.24219,0.242187 z m 0,0",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.51953,40.320312 -0.12109,2.160157 v -2.039063 z m 0,0",
    id: "path263"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.51953,40.320312 v 2.28125 l -0.12109,-0.121093 z m 0,0",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.39844,40.441406 -0.23828,1.679688 v -1.320313 z m 0,0",
    id: "path265"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.39844,40.441406 v 2.039063 l -0.23828,-0.359375 z m 0,0",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.16016,40.800781 -0.1211,1.078125 v -0.839844 z m 0,0",
    id: "path267"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 299.16016,40.800781 v 1.320313 l -0.1211,-0.242188 z m 0,0",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,0.00188233 H 0.158345 V 0.158132 L 0.319804,0.319591 H 0.637512 V 0.481049 H 1.121887 V 0.642507 H 1.601054 V 0.481049 0.642507 H 1.918762 V 0.481049 H 2.397929 V 0.319591 L 2.559387,0.158132 H 2.882304 V 0.00188233 L 3.038554,-0.159576 H 3.200012 V -0.482493 H 3.36147 v -0.15625 H 3.51772 V -2.237701 L 3.36147,-2.399159 3.200012,-2.560618 V -2.878326 H 2.882304 V -3.201243 H 2.559387 v -0.15625 H 2.397929 V -3.518951 H 1.918762 v -0.161458 h -0.15625 v 0.161458 H 1.439595 V -3.680409 H 1.121887 v 0.161458 H 0.79897",
    transform: "matrix(0.75,0,0,0.75,303.59999,43.439995)",
    id: "path269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,0.001045 H -0.162506 v 0.161458 h -0.317708 l -0.161459,0.15625 V 0.480212 H -0.959381 V 0.79792 h -0.161458 v 0.161458 h -0.161459 v 0.322917 l -0.15625,0.15625 v 1.28125 h 0.15625 v 0.317708 h 0.161459 v 0.161459 h 0.161458 v 0.322916 h 0.161458",
    transform: "matrix(0.75,0,0,0.75,304.2,40.799998)",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001862,0.00208967 V 0.319798 h -0.161458 v 0.317708 h -0.161459 v 0.161459 h -0.161458 v 0.322916 h -0.15625 l -0.161458,0.15625 V 1.43959 H -1.279388 V 1.601048 H -1.758555 V 1.762506 H -2.237721 V 1.601048 1.762506 H -2.560638 V 1.601048 H -3.039805 V 1.43959 L -3.201263,1.278131 H -3.518971 V 1.121881 L -3.68043,0.960423 H -3.841888 V 0.637506 L -4.159596,0.319798 h 0.161458 V 0.15834 h -0.161458 v -0.958334 l 0.161458,-0.161458 v -0.15625 h -0.161458 0.161458 V -1.27916 h 0.15625 v -0.479167 h 0.322917 v -0.322917 h 0.317708 v -0.15625 h 0.161458 v -0.161458 h 0.479167",
    transform: "matrix(0.75,0,0,0.75,298.44001,42.599995)",
    id: "path271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -6.1e-4,0.001045 v -0.161458 h 0.161458 l 0.161459,0.161458 h 0.15625 V -0.160413 H 0.801473 V 0.001045 H 1.28064 V 0.162503 H 1.759807 V 0.480212 H 2.077515 V 0.79792 H 2.238973 V 0.959378 H 2.400432 V 1.282295 L 2.56189,1.438545 V 1.917712 H 2.71814 V 2.07917 H 2.56189 v 0.322917",
    transform: "matrix(0.75,0,0,0.75,296.51999,40.799998)",
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,-6.20667e-4 -5.117493,0.478546 l -5.125,1.119792 -4.796875,1.604166 -4.640625,2.239584 -4.317708,2.71875 -4,3.359375 -1.442709,1.598958 -1.119791,1.921875 -0.802084,2.078125 -0.479166,2.083333 v 2.239584 l 0.322916,2.239583 0.796875,2.078125 1.760417,2.880208 2.083333,2.5625 2.557292,2.239584 2.880208,1.916666 3.041667,1.28125 3.359375,0.802084 3.359375,0.317708 H 14.55959 l 3.359375,-0.317708 3.203125,-0.802084 3.036459,-1.28125 2.880208,-1.916666 2.5625,-2.239584 2.078125,-2.5625 1.760417,-2.880208 0.802083,-2.078125 0.317708,-2.239583 v -2.239584 l -0.479166,-2.083333 -0.802084,-2.078125 -1.119791,-1.921875 -1.4375,-1.598958 -4,-3.359375 L 22.398132,5.442088 17.757507,3.202504 12.960632,1.598338 7.84084,0.478546 2.721049,-6.20667e-4",
    transform: "matrix(0.75,0,0,0.75,299.75999,44.519997)",
    id: "path273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 414.23958,102.23959 H 388",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,0.00145967 0.161865,3.678543 0.95874,7.360835 l 1.442708,3.520833 1.760417,3.197917 2.239583,3.041666 2.557292,2.557292 3.041667,2.239583 3.359375,1.921875 3.359375,1.28125 3.682291,0.796875 3.838542,0.161459",
    transform: "matrix(0.75,0,0,0.75,271.32001,57.119999)",
    id: "path275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 361.76042,76.161464 V 53.281255 l 3.52083,-3.359375 h 71.67708 l 3.35938,3.359375 v 22.880209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -4.06667e-4,-4.09333e-4 3.681885,-0.161868 l 3.677083,-0.796875 3.520834,-1.28125 3.197916,-1.921875 3.041667,-2.239583 2.5625,-2.557292 2.239583,-3.041666 1.916667,-3.197917 1.28125,-3.520833 0.802083,-3.682292 0.15625,-3.677083",
    transform: "matrix(0.75,0,0,0.75,310.67999,76.679995)",
    id: "path277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,8.38667e-4 0.160207,-0.322078 -0.001251,-0.639786 v -0.317709 l -0.15625,-0.322916 -0.322917,-0.161459 -0.161458,-0.317708 -0.317708,-0.161458 h -0.322917 l -0.479167,-0.161459 -0.317708,0.161459 h -0.322917 l -0.317708,0.161458 -0.161458,0.317708 -0.317709,0.161459 -0.161458,0.322916 V 8.38667e-4 l 0.802083,9.916666333 0.15625,0.161459 v 0.161458 l 0.161459,0.161458 h 0.322916 l 0.317709,0.15625 0.161458,-0.15625 h 0.317708 l 0.161459,-0.161458 V 10.078964 L -0.798126,9.917505 0.160207,-0.16062 -0.798126,9.917505",
    transform: "matrix(0.75,0,0,0.75,302.04,41.639996)",
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00145433,-0.00249667 V 0.158962 H 0.157704 V 0.32042 l 0.161459,0.161458 h 0.479166 l 0.161459,0.15625 0.161458,-0.15625 H 1.438954 L 1.761871,0.158962 v -0.16145867",
    transform: "matrix(0.75,0,0,0.75,300.12,49.079998)",
    id: "path279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -2.03333e-4,6.31333e-4 0.80188,-0.160827 1.760213,-0.322285 2.562297,-0.801452 3.359172,-1.442077 3.838338,-2.077494 4.317505,-2.879577 4.640422,-3.83791 4.80188,-4.639994 V -5.598327 L 4.478963,-6.561869 4.161255,-7.358744 3.682088,-8.160827 2.880005,-8.801452 2.23938,-9.280619 1.281047,-9.598327 0.317505,-9.759785 H -0.47937 l -0.958333,0.161458 -0.802084,0.317708 -0.802083,0.479167 -0.796875,0.640625 -0.479167,0.802083 -0.322916,0.796875 -0.317709,0.963542 v 0.958333 l 0.15625,0.802084 0.322917,0.958333 0.479167,0.802083 0.479166,0.635417 0.802084,0.640625 0.796875,0.479167 0.963541,0.161458 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,300.84,57.479995)",
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,8.38667e-4 0.160207,-0.322078 -0.001251,-0.639786 v -0.317709 l -0.15625,-0.322916 -0.322917,-0.161459 -0.161458,-0.317708 -0.317708,-0.161458 h -0.322917 l -0.317708,-0.161459 -0.479167,0.161459 h -0.322917 l -0.317708,0.161458 -0.161458,0.317708 -0.317709,0.161459 -0.161458,0.322916 V 8.38667e-4",
    transform: "matrix(0.75,0,0,0.75,302.04,41.639996)",
    id: "path281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 399.35937,55.35938 0.80209,10.078125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 293.59896,210.88021 h 209.76041 v 12.95834 H 293.59896 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,2.08667e-4 -1.282298,0.958542 l -0.958333,1.28125 -0.640625,1.28125 -0.479167,1.4375 -0.161458,1.598958 0.161458,1.604167 0.479167,1.4375 0.640625,1.28125 0.958333,1.28125 1.28125033,0.958333",
    transform: "matrix(0.75,0,0,0.75,220.2,158.16)",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -6.1e-4,5.33333e-6 1.28064,-0.958328 l 0.958333,-1.28125 0.640625,-1.28125 0.479167,-1.4375 0.161458,-1.604167 -0.161458,-1.598958 -0.479167,-1.4375 -0.640625,-1.28125 -0.958333,-1.28125 -1.28125,-0.958333",
    transform: "matrix(0.75,0,0,0.75,377.51999,168)",
    id: "path287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 293.59896,217.4375 H 503.35937",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path288"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g288"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 269.16177,
    y: 155.4034,
    id: "use288"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6327.5031,3458.901 c 8.801,3.8617 13.2914,13.1118 13.2914,27.6604 0,4.1311 -0.5389,8.1724 -1.4369,12.2137 l -5.7477,21.1944 c -6.2864,23.5293 -18.5899,39.1557 -37.0003,47.0586 -9.3399,3.8617 -20.0268,5.7477 -31.9711,5.7477 h -40.9518 c -7.0049,0 -10.4176,-3.4127 -10.4176,-10.4176 0,-7.1845 3.4127,-10.7768 10.4176,-10.7768 h 46.6994 c 9.0705,0 17.6021,-2.9636 25.5051,-8.9807 8.0826,-6.1966 13.3812,-13.7404 15.8059,-22.6312 l 5.7477,-21.1944 c 0.898,-4.3107 1.4369,-8.2622 1.4369,-11.8544 0,-13.1118 -8.6215,-19.7575 -25.8643,-19.7575 h -19.039 c -7.1846,0 -10.7768,-3.4126 -10.7768,-10.4176 0,-7.1845 3.5922,-10.7767 10.7768,-10.7767 h 24.7866 c 12.6627,0 23.5293,-5.2088 32.6896,-15.806 4.3107,-4.7598 7.1845,-10.0583 8.6214,-15.806 0.7185,-3.5922 1.0777,-6.6457 1.0777,-9.3399 0,-14.818 -8.5316,-22.272 -25.5051,-22.272 h -40.9518 c -7.0049,0 -10.4176,-3.5923 -10.4176,-10.7768 0,-6.9151 3.4127,-10.4175 10.4176,-10.4175 h 46.6994 c 16.5245,0 28.5585,7.3641 36.2819,21.9128 3.5923,6.7355 5.3884,13.6506 5.3884,20.8351 0,3.4126 -0.5388,6.7355 -1.4369,10.0583 -6.017,22.9905 -17.4225,37.8984 -34.1265,44.5441 z m 0,0",
    transform: "matrix(0.0434963,0,0,0.0434963,0,-4e-6)",
    id: "path289"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g289"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-1",
    x: 275.71021,
    y: 155.4034,
    id: "use289"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6420.6325,3551.5814 c 21.7332,0 35.6532,-10.5074 41.6703,-31.6119 l 5.7476,-21.1944 c 0.8981,-4.3107 1.4369,-8.2622 1.4369,-11.8544 0,-13.1118 -8.801,-19.7575 -26.2235,-19.7575 h -32.6896 l -14.0098,52.8063 c -0.9879,3.1432 -1.4369,5.7476 -1.4369,7.903 0,7.1845 2.3349,12.9321 7.1845,17.2428 5.0291,4.3107 11.136,6.4661 18.3205,6.4661 z m -5.3884,21.1944 c -15.0875,0 -27.1216,-7.7234 -35.9226,-23.3498 -3.8617,-6.6456 -5.7476,-13.6506 -5.7476,-20.8351 0,-2.8738 0.3592,-5.568 1.0776,-8.2622 l 16.8837,-63.5831 c 6.4661,-23.7089 16.9734,-43.2867 31.6119,-58.9131 16.704,-17.6919 38.4372,-29.6362 65.02,-35.9226 0.7184,-0.1796 1.5267,-0.3592 2.5146,-0.3592 7.1845,0 10.7768,3.5024 10.7768,10.4175 0,6.0171 -2.4248,9.3399 -7.1846,10.0584 -11.7646,1.7063 -23.6191,6.1068 -35.5634,13.2913 -21.3739,12.9322 -35.0246,29.8158 -40.9518,50.651 h 31.2527 c 12.2137,0 22.272,3.8616 30.175,11.4952 8.0826,7.7234 12.2137,17.6021 12.2137,29.8158 0,4.1311 -0.5388,7.903 -1.4369,11.4952 l -5.7476,21.1944 c -7.0049,24.6968 -18.9492,40.5028 -35.9226,47.4179 -8.8909,3.5922 -19.9371,5.3884 -33.0489,5.3884 z m 0,0",
    transform: "matrix(0.0434963,0,0,0.0434963,0,-4e-6)",
    id: "path290"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g290"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-2",
    x: 282.25867,
    y: 155.4034,
    id: "use290"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6638.6829,3468.6001 -61.0685,99.1465 c -2.1553,3.4126 -5.2087,5.0292 -8.9806,5.0292 -2.8738,0 -5.3884,-1.0777 -7.5438,-3.2331 -2.1553,-2.1553 -3.1432,-4.6699 -2.8738,-7.5437 l 6.8253,-190.39 c 0.1796,-6.6457 3.7719,-10.0583 10.7768,-10.0583 7.3642,0 10.9564,3.7718 10.7768,11.136 l -6.1068,150.1566 56.7577,-92.6804 c 2.1554,-3.5923 5.0292,-5.3884 8.6215,-5.3884 6.9151,0 10.5971,3.4126 11.136,10.0583 l 7.1845,89.4474 77.2337,-156.9819 c 1.8859,-3.7719 5.0291,-5.7476 9.3399,-5.7476 7.1845,0 10.7768,3.4126 10.7768,10.0583 0,1.9757 -0.3593,3.5923 -1.0777,5.0292 l -94.4766,190.3899 c -1.9757,3.8617 -5.0291,5.7477 -9.3398,5.7477 -6.7355,0 -10.3278,-3.2331 -10.7768,-9.6991 z m 0,0",
    transform: "matrix(0.0434963,0,0,0.0434963,0,-4e-6)",
    id: "path291"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g291"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-3",
    x: 301.32114,
    y: 155.15982,
    id: "use291"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7050.7156,3546.0134 c 6.9151,0 10.4175,3.5923 10.4175,10.7768 0,7.0049 -3.5024,10.4176 -10.4175,10.4176 h -90.5251 c -3.1432,0 -5.568,-0.8981 -7.1845,-2.8739 -1.4369,-2.1553 -1.7063,-4.6699 -0.7184,-7.5437 l 51.7286,-192.9046 c 1.4369,-5.2088 4.7597,-7.903 10.0583,-7.903 6.9151,0 10.4176,3.5025 10.4176,10.4176 0,1.2573 0,2.1554 0,2.8738 l -47.4179,176.7394 z m 0,0",
    transform: "matrix(0.0434963,0,0,0.0434963,0,-4e-6)",
    id: "path292"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g292"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-4",
    x: 307.8696,
    y: 155.15982,
    id: "use292"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7207.7873,3461.5952 h -57.4762 l -22.6313,84.4182 h 73.6414 c 6.9151,0 10.4176,3.5923 10.4176,10.7768 0,7.0049 -3.5025,10.4176 -10.4176,10.4176 h -90.525 c -3.1432,0 -5.568,-0.8981 -7.1845,-2.8739 -1.4369,-2.1553 -1.7064,-4.6699 -0.7185,-7.5437 l 51.0102,-190.39 c 1.6165,-6.9151 6.1966,-10.4176 13.6506,-10.4176 h 84.4182 c 7.1845,0 10.7767,3.5025 10.7767,10.4176 0,7.1845 -3.5922,10.7768 -10.7767,10.7768 h -79.0298 l -16.8837,63.2238 h 51.7286 c 6.9151,0 10.4176,3.5923 10.4176,10.7768 0,7.005 -3.5025,10.4176 -10.4176,10.4176 z m 0,0",
    transform: "matrix(0.0434963,0,0,0.0434963,0,-4e-6)",
    id: "path293"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g293"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-5",
    x: 314.41803,
    y: 155.15982,
    id: "use293"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 7304.4192,3366.4002 c 1.6165,-6.9151 6.1967,-10.4176 13.6506,-10.4176 h 65.7384 c 10.9564,0 20.6555,4.67 29.0974,14.0099 8.352,9.1602 12.5729,19.3084 12.5729,30.5342 0,2.6942 -0.3592,5.3884 -1.0777,8.2622 l -28.3789,105.6126 c -9.6093,35.2042 -32.5998,52.8063 -68.9714,52.8063 h -65.7385 c -3.1432,0 -5.568,-0.8981 -7.1845,-2.8739 -1.4369,-2.1553 -1.7063,-4.6699 -0.7184,-7.5437 z m 19.039,10.7768 -45.2625,168.8364 h 54.6024 c 8.801,0 17.3327,-2.9636 25.5051,-8.9807 8.0826,-6.1966 13.3811,-13.7404 15.8059,-22.6312 l 28.3789,-105.6126 c 0.7185,-2.8738 1.0777,-5.4782 1.0777,-7.903 0,-7.1845 -2.5146,-12.9321 -7.5438,-17.2428 -4.8495,-4.3107 -10.7768,-6.4661 -17.9613,-6.4661 z m 0,0",
    transform: "matrix(0.0434963,0,0,0.0434963,0,-4e-6)",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 401.76042,194.07813 h 31.52083 v 13.44271 h -31.52083 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path295"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/житловий план.2e9311d6c0091b87e084f8ce7b0431e8.svg";
export { ForwardRef as ReactComponent };